import { render } from "./CoursesContent.vue?vue&type=template&id=66fb2b84"
import script from "./CoursesContent.vue?vue&type=script&lang=js"
export * from "./CoursesContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__